import { gql } from '@/__generated__';

/**
 * Corregir el ticket abierto sin cerrarlo ni abrir otro (AMARU-736). Todos los campos del input son
 * opcionales: lo que no viaja no se toca.
 */
const UPDATE_DGA_TICKET = gql(`#graphql
  mutation UpdateDgaTicket($deviceId: ID!, $input: UpdateDgaTicketInput!) {
    updateDgaTicket(deviceId: $deviceId, input: $input) {
      id
      dga {
        id
        ticket {
          id
          timestamp
          description
        }
      }
    }
  }
`);

export default UPDATE_DGA_TICKET;
